import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import GlobalStyles from './styles/GlobalStyles';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTopOnNavigation from './components/ScrollToTopOnNavigation';
import ScrollToTopButton from './components/ScrollToTopButton';
import PageTitle from './components/PageTitle'; // Import the new component

// Pages
import Home from './pages/Home';
import PersBefo from './pages/PersBefo';
import Sicherheit from './pages/Sicherheit';
import Reinigung from './pages/Reinigung';
import Jobs from './pages/Jobs';
import Impressum from './pages/Impressum';
import Datenschutz from './pages/Datenschutz';

function App() {
  return (
    <BrowserRouter>
      <GlobalStyles />
      <PageTitle /> {/* Add this component to dynamically set the page title */}
      <ScrollToTopOnNavigation />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/index.html" element={<Home />} />
        <Route path="/index" element={<Home />} />
        
        {/* Clean URL routes */}
        <Route path="/taxi" element={<PersBefo />} />
        <Route path="/sicherheit" element={<Sicherheit />} />
        <Route path="/reinigung" element={<Reinigung />} />
        <Route path="/jobs" element={<Jobs />} />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/datenschutz" element={<Datenschutz />} />
        
        {/* Legacy .html routes (for backward compatibility) */}
        <Route path="/persbefo.html" element={<PersBefo />} />
        <Route path="/sicherheit.html" element={<Sicherheit />} />
        <Route path="/reinigung.html" element={<Reinigung />} />
        <Route path="/jobs.html" element={<Jobs />} />
        <Route path="/impressum.html" element={<Impressum />} />
        <Route path="/datenschutz.html" element={<Datenschutz />} />
      </Routes>
      <Footer />
      <ScrollToTopButton />
    </BrowserRouter>
  );
}

export default App;